@use "../styles/variables" as v;

@mixin ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cnc-page-header {
  .sub-title-section {
    @include ellipsis-2;
  }
  .action-section {
    flex-shrink: 0;
  }
  > .header {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row nowrap;
    justify-content: space-between;
    .title-section {
      display: flex;
      flex: 1 2 auto;
      min-width: 0;
      flex-flow: column nowrap;
      .title-with-status {
        display: flex;
        flex: 0 0 auto;
        flex-flow: row nowrap;
        align-items: center;
      }
    }
  }
  .page-tabs {
    flex: 1 !important;
  }
}
.candidate-action-header {
  border-bottom: 2px solid var(--control-icon-default);;
  background-color: var(--base-bg-default);
  top: 0;
  padding-bottom: v.$unit;
}
